/**   
 * 系统管理
 */
export default {
  /**
   * 用户信息
   */
  addSysUser: "/sysUser/addSysUser", //新增
  deleteSysUser: "/sysUser/deleteSysUser", //删除/{userId}
  getSysUserList: "/sysUser/getSysUserList", //列表
  getSysUserById: "/sysUser/getSysUserById", //详情/{userId}
  updateSysUser: "/sysUser/updateSysUser", //修改

  /**
   * 角色信息
   */
  addSysRole: "/sysRole/addSysRole", //新增
  deleteSysRole: "/sysRole/deleteSysRole", //删除/{roleId}
  getSysRoleList: "/sysRole/getSysRoleList", //列表
  getSysRole: "/sysRole/getSysRole", //详情/{roleId}
  updateSysRole: "/sysRole/updateSysRole", //修改

  /**
   * 菜单信息
   */
  addSysMenu: "/sysMenu/addSysMenu", //新增
  deleteSysMenu: "/sysMenu/deleteSysMenu", //删除/{menuId}
  getSysMenuList: "/sysMenu/getSysMenuList", //列表
  getSysMenu: "/sysMenu/getSysMenu", //详情/{menuId}
  updateSysMenu: "/sysMenu/updateSysMenu", //修改

  /**
   * 用户角色授权信息
   */
  addSysUserRole: "/sysUserRole/addSysUserRole", //新增
  deleteSysUserRole: "/sysUserRole/deleteSysUserRole", //取消授权
  getSysUserRoleList: "/sysUserRole/getSysUserRoleList", //列表
};